/**
 * Helpers puros do modal de devolução (ReturnInvoiceModal), livres de React para teste unitário.
 */

/**
 * Normaliza o número de NF digitado na busca do seletor de nota de origem.
 *
 * A API compara `CAST(Number AS NVARCHAR) LIKE %termo%`, então só dígitos casam. O usuário copia o
 * número do jeito que aparece na tela ("NF 5445/1", "005.445"): a série depois da barra, pontos,
 * espaços e zeros à esquerda saem. Sem nenhum dígito, devolve `undefined` (busca sem filtro de número).
 */
export const normalizeInvoiceNumberSearch = (raw: string | null | undefined): string | undefined => {
  if (!raw) return undefined;
  const beforeSerie = raw.split('/')[0];
  const digits = beforeSerie.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
  return digits.length > 0 ? digits : undefined;
};
